import type { MenuGrupoDinamico, MenuItemDinamico } from '@/hooks/useMenuDinamico';

/**
 * Resolve uma verificação dinâmica para um item de menu.
 *
 * Hoje só conhecemos a flag `avaliador`, mas a função foi escrita de forma
 * declarativa para que novas flags possam ser adicionadas sem mexer no
 * componente da sidebar.
 */
export interface ChecagensDinamicas {
  avaliador: boolean;
}

const passaNaChecagemDinamica = (
  item: MenuItemDinamico,
  flags: ChecagensDinamicas,
): boolean => {
  if (!item.dynamicCheck) return true;
  switch (item.dynamicCheck) {
    case 'avaliador':
      return flags.avaliador;
    default:
      // Flag desconhecida: por segurança, escondemos o item até que ela seja
      // explicitamente mapeada aqui.
      return false;
  }
};

/**
 * Recebe a estrutura crua vinda do hook `useMenuDinamico` e devolve apenas
 * os grupos visíveis para o usuário atual, já ordenados.
 *
 * Centralizar essa lógica facilita testes e permite que a sidebar fique
 * apenas com a responsabilidade de renderizar o menu.
 */
export const montarMenuVisivel = (
  grupos: MenuGrupoDinamico[],
  flags: ChecagensDinamicas,
): MenuGrupoDinamico[] => {
  return grupos
    .map((grupo) => ({
      ...grupo,
      items: grupo.items.filter((item) => passaNaChecagemDinamica(item, flags)),
    }))
    .filter((grupo) => grupo.items.length > 0);
};
